import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient.ts';
import { useAuth } from '../contexts/AuthContext.tsx';
import { PartnerInfo } from '../types/partners.ts';

// Hook to get partner info with React Query caching
export function usePartner(): UseQueryResult<PartnerInfo | null, Error> {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['partner', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
      .from('partners')
      .select('*')
      .eq('user_id', user!.id)
      .maybeSingle();
  
    if (error) {
      console.error('Failed to get partner from database:', error);
      throw new Error(`Failed to get partner info: ${error.message}`);
    }
    return data;
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
}


